// Import global styles
import "./src/styles/global.css";
import React from "react";
import { LanguageProvider } from "./src/contexts/LanguageContext";
import { ThemeProvider } from "./src/contexts/ThemeContext";
import { installAnalyticsTracking } from "./src/utils/analytics";

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider>
      <LanguageProvider>{element}</LanguageProvider>
    </ThemeProvider>
  );
};

export const onClientEntry = () => {
  installAnalyticsTracking();
};
